import { useAuthStore } from '@/stores/auth.store';
import { canAccess, type AccessRule } from '@/utils/permissions';

/** True when the signed-in user satisfies the rule. Re-renders when the session changes. */
export function useCan(rule: AccessRule): boolean {
  const user = useAuthStore((s) => s.user);
  return canAccess(user, rule);
}
